import React, { Component } from "react";
import SocialIcon from "./SocialIcon";
import './styles.scss';

const defaultAccountValues = [
  "https://www.facebook.com/yourname",
  "https://www.instagram.com/yourname"
];

class SocialLink extends Component {
  state = {
    tooltipOpen: false
  };

  toggle = () => this.setState({ tooltipOpen: !this.state.tooltipOpen });

  render() {
    const { socialItem } = this.props;

    return (
      <React.Fragment>
        {defaultAccountValues.includes(socialItem.name) ? (
          <div />
        ) : (
          <div
            className="col-3 col-sm-2 col-md-2 col-lg-2 social-link-container"
            key={socialItem.img_url}
            onClick={() => window.open(socialItem.name, "_blank")}
          >
            <SocialIcon socialName={socialItem.social_type} />
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default SocialLink;



// WEBPACK FOOTER //
// ./src/components/SocialLink/SocialLink.jsx